export default function PHP_GLOBALS() {
  return (
    <div>
      <h1>PHP_GLOBALS</h1>
    </div>
  );
}
